import { render, staticRenderFns } from "./WheelchairAccessoriesTable.vue?vue&type=template&id=7f61e61b"
import script from "./WheelchairAccessoriesTable.vue?vue&type=script&lang=js"
export * from "./WheelchairAccessoriesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports